import React  from 'react';
import {FieldViewProps} from "../../../render/view";

export default function FieldEstimate_ViewSmall(props:FieldViewProps) {

    // const value = _.get(props.model, props.field.fieldId, null)
    const value = props.field.getViewValue(props.model)

    if (_.isNil(value)) return false;

    return (
        <div className={Classes("ui5-txt-less-important-small", props.className)}>
            <span className="txt-truncate">{gd.utils.minutesHumanize(value)}</span>
        </div>
    );


}
